import { Component, Input, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { TealiumService } from 'src/app/services/tealium.service';

@Component({
    selector: 'app-mgn-my-downloads',
    templateUrl: './mgn-my-downloads.component.html',
    styleUrls: ['./mgn-my-downloads.component.less'],
    standalone: false
})
export class MgnMyDownloadsComponent implements OnInit {

  downloadUrlData: {
    ID: number,
    PACKAGE_ID: number,
    NAME: string,
    URL_DESC: string
  }[] = [];
  oemName!: string;
  @Input() package: any;
  @Input() formDataDropDown: any;
  downloadPopupToggle = false;
  popupDisplayData = {};
  rtlLocale = '';
  selectedLocale = false;
  selectedRegionDK = false;
  selectedLocaleDateHRline = false;
  selectedLocalePLMXCZDK = false;
  selectedLocaleNO = false;
  extendMarginToggle = false;
  selectedRegionTR = false;
  constructor(
    private dataService: DataService,
    private translate: TranslateService,
    private tealiumService: TealiumService
  ) {
    if (this.translate.currentLang === 'mitsubishi/ar') {
      this.rtlLocale = 'rtl';
    } else {
      this.rtlLocale = 'non-rtl';
    }
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.package = [];
      if (this.translate.currentLang === 'mitsubishi/ar') {
        this.rtlLocale = 'rtl';
      } else {
        this.rtlLocale = 'non-rtl';
      }
    });
  }

  ngOnInit(): void {
    this.oemName = this.dataService.getOemName();
    this.checkForLocale(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.package = [];
      this.checkForLocale(this.translate.currentLang);
    });
  }

  checkForLocale(localeName: string) {
    switch (localeName) {
      case 'mitsubishi/tr_TR':
        this.selectedLocale = true;
        this.extendMarginToggle = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocaleDateHRline = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/sv_SE':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/pt_PT':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/it_IT':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = true;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/in':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/fr_CA':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/fr_FR':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/fi_FI':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/es_ES':
        this.selectedLocaleDateHRline = true;
        this.selectedLocale = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/pl_PL':
        this.selectedLocalePLMXCZDK = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.extendMarginToggle = false;
        break;
      case 'mitsubishi/es_MX':
        this.selectedLocalePLMXCZDK = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.extendMarginToggle = false;
        break;
      case 'mitsubishi/cs_CZ':
        this.selectedLocalePLMXCZDK = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        break;
      case 'mitsubishi/da_DK':
        this.selectedLocalePLMXCZDK = true;
        this.selectedRegionDK = true;
        this.selectedLocaleDateHRline = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.extendMarginToggle = false;
        break;
      case 'mitsubishi/nb_NO':
        this.selectedLocaleNO = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocale = false;
        this.extendMarginToggle = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/de_DE':
        this.extendMarginToggle = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/pt_BR':
        this.extendMarginToggle = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      case 'mitsubishi/ru_RU':
        this.extendMarginToggle = true;
        this.selectedLocaleDateHRline = false;
        this.selectedRegionDK = false;
        this.selectedLocaleNO = false;
        this.selectedLocale = false;
        this.selectedLocalePLMXCZDK = false;
        break;
      default:
        this.selectedLocale = false;
        this.selectedLocaleDateHRline = false;
        this.selectedLocalePLMXCZDK = false;
        this.selectedLocaleNO = false;
        this.extendMarginToggle = false;
        this.selectedRegionTR = true;
        break;
    }
  }

  ngOnChanges(): void {
    if (this.selectedLocale) {
      for (const val of this.package) {
        this.translate.get(val[0].NAME).subscribe((result: any) => {
          if (result === 'Afrika'
            || result === 'Rusya'
            || result === 'Orta Doğu (İsrail hariç)'
            || result === 'İsrail'
          ) {
            this.selectedRegionTR = false;
          } else {
            this.selectedRegionTR = true;
          }
        });
      }
    }
  }

  getUrlData(id: number, name: string, version: string, size?: string) {
    this.downloadUrlData = [];
    this.downloadUrlData = this.dataService.getUrlMapData(id);
    this.popupDisplayData = {
      mapName: name,
      mapVersion: version
    }
    this.downloadPopupToggle = true;
    this.tealiumService.trackEvent({
      event_name: 'navshop_click',
      click_text: 'click_on_download_button',
      map_name: name,
      map_version: version,
      map_size: size,
      car_brand: this.formDataDropDown.car_brand,
      car_model: this.formDataDropDown.car_model
    });
  }

  closePopup(e: any) {
    this.downloadPopupToggle = e;
  }
}